export default __webpack_public_path__ + "static/MmmRev-0967895a7a789314e2d806200f41f188.jpg";